import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import {
  createNewCustomer,
  deleteCustomerById,
  getCustomerById,
  getCustomersByWorkspace,
  updateCustomerById,
} from '../thunks/customers';

const customersAdapter = createEntityAdapter({});

export const customersSlice = createSlice({
  name: 'customers',
  initialState: customersAdapter.getInitialState({
    status: 'idle',
    error: null,
  }),
  reducers: {
    setCustomers: (state, action) => {
      customersAdapter.upsertMany(state, action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCustomersByWorkspace.fulfilled, (state, action) => {
        state.status = 'fulfilled';
        customersAdapter.upsertMany(state, action.payload);
      })
      .addCase(getCustomersByWorkspace.pending, (state) => {
        state.status = 'pending';
        state.error = null;
      })
      .addCase(getCustomersByWorkspace.rejected, (state, action) => {
        state.status = 'rejected';
        state.error = action.payload;
      })
      .addCase(createNewCustomer.fulfilled, (state, action) => {
        customersAdapter.upsertOne(state, action.payload);
      })
      .addCase(getCustomerById.fulfilled, (state, action) => {
        customersAdapter.upsertOne(state, action.payload);
      })
      .addCase(updateCustomerById.fulfilled, (state, action) => {
        const { id: customerId, ...data } = action.payload;
        customersAdapter.updateOne(state, {
          id: customerId,
          changes: data,
        });
      })
      .addCase(deleteCustomerById.fulfilled, (state, action) => {
        customersAdapter.removeOne(state, action.payload.id);
      });
  },
});

export const { setCustomers } = customersSlice.actions;

export const customersAdapterSelectors = customersAdapter.getSelectors(
  (state) => state.customers
);

export default customersSlice.reducer;
